"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const analytics_package_1 = __importDefault(require("@alcumus/analytics-package"));
const styles_1 = require("@material-ui/core/styles");
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const PermIdentityOutlined_1 = __importDefault(require("@material-ui/icons/PermIdentityOutlined"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const components_1 = require("@alcumus/components");
const material_1 = require("@mui/material");
const recoil_1 = require("recoil");
const ChangePasswordModal_1 = __importDefault(require("../../Modals/ChangePasswordModal"));
const ChangePasswordModal_2 = require("../../Modals/ChangePasswordModal/ChangePasswordModal");
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    userContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    userProfileMenu: {
        '& .MuiPaper-root': {
            borderRadius: theme.spacing(1),
            boxShadow: `0px 2px 8px ${components_1.StyleVariables.colors.boxShadowGrey}`,
        },
    },
    userProfile: {
        marginLeft: '1rem',
        width: '35px',
        height: '35px',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: components_1.StyleVariables.colors.grey2,
        },
        '&:active': {
            backgroundColor: components_1.StyleVariables.colors.surface.selected,
            color: components_1.StyleVariables.colors.action.primary.default,
        },
    },
    userName: {
        fontWeight: components_1.StyleVariables.fonts.weight.medium,
        color: components_1.StyleVariables.colors.text.subdued,
    },
}));
function UserMenu({ onLogout, t }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const userFirstName = localStorage.getItem('user_first_name') ?? '';
    const userLastName = localStorage.getItem('user_last_name') ?? '';
    const setOpenChangePasswordModal = (0, recoil_1.useSetRecoilState)(ChangePasswordModal_2.changePasswordModalVisibleState);
    const handleProfileMenuOpen = (event) => {
        analytics_package_1.default.getInstance().trackWithCategory('Menu', 'Profile Menu Opened');
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    const handleLogout = () => {
        onLogout();
        setAnchorEl(null);
        analytics_package_1.default.getInstance().trackWithCategory('Logout', 'User logged out');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ChangePasswordModal_1.default, null),
        react_1.default.createElement(components_1.Text, { className: classes.userName },
            userFirstName || react_1.default.createElement(material_1.Skeleton, { width: 100 }),
            " ",
            userLastName),
        react_1.default.createElement(IconButton_1.default, { className: classes.userProfile, "aria-label": "User Menu", onClick: handleProfileMenuOpen, "data-testid": "userMenuIcon", disableRipple: true },
            react_1.default.createElement(PermIdentityOutlined_1.default, { style: { fontSize: components_1.StyleVariables.fonts.size.h2 } })),
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorEl, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, id: "primary-search-account-menu", keepMounted: true, open: isMenuOpen, onClose: handleMenuClose, getContentAnchorEl: null, className: classes.userProfileMenu },
            react_1.default.createElement(MenuItem_1.default, { "data-testid": "editPasswordMenuItem", onClick: () => setOpenChangePasswordModal(true) }, t('editPassword')),
            react_1.default.createElement(MenuItem_1.default, { "data-testid": "logoutLink", onClick: handleLogout }, t('logout')))));
}
exports.default = UserMenu;
